module.exports = __webpack_public_path__ + "static/media/main-menu-intro.f0771d02.wav";